module.exports = __webpack_public_path__ + "a923472d735951784e99366c231a251b.jpg";